export type SignupStep = 'profile' | 'dl' | 'aadhaar' | 'pan';

export interface SignupState {
  name: string;
  phone: string;
  photoDataUrl: string;

  dlNumber: string;
  dlExpiry: string;
  dlPhotoDataUrl: string;

  aadhaarNumber: string;
  aadhaarPhotoDataUrl: string;

  panNumber: string;
  panPhotoDataUrl: string;
}

export const SIGNUP_STEPS: SignupStep[] = ['profile', 'dl', 'aadhaar', 'pan'];

export const INITIAL_SIGNUP_STATE: SignupState = {
  name: '',
  phone: '',
  photoDataUrl: '',
  dlNumber: '',
  dlExpiry: '',
  dlPhotoDataUrl: '',
  aadhaarNumber: '',
  aadhaarPhotoDataUrl: '',
  panNumber: '',
  panPhotoDataUrl: '',
};
